import { signal } from 'services/SignalsService'
import { brand } from 'settings/custom/build'
import { gameId } from 'settings/custom/general'
import { noop } from 'utils/Mocks'

const defaults = {
  win: 3,
  loss: 3,
  auto: 2,
  intro: true,
  space: true,
  sound: false,
  left: false,
  bonusMultiplier: 0,
  error: null,
}

let id
let values
let store = function () {
  localStorage.setItem(id, JSON.stringify(values))
}

window.onerror =  (arg1, arg2, arg3, arg4, error) => {
  StoreageService.set('error', `${error}`)
}
window.addEventListener('unhandledrejection',  (event) => {
  StoreageService.set('error', `${event.reason.message} ${event.reason.stack}`)
})

signal.once('INIT:GAME', function () {
  id = `${brand}-${gameId}-${game.models.UserModel.get().playerId}`
  try {
    values = JSON.parse(localStorage.getItem(id))
  }
  catch (e) {
    store = noop
  }
  values = values || defaults

  Object.keys(defaults)
    .forEach((key) => {
      !Object.keys(values).includes(key) && (values[key] = defaults[key])
    })
})

export const StoreageService = {
  get,
  set,
}

function get(name) {
  return values[name]
}

function set(name, value) {
  values[name] = value
  store()
}
